export const normalizeBlockedPath = (path) => {
  if (!path || path === '#') return '';
  const withoutQuery = String(path).split('?')[0].split('#')[0];
  if (!withoutQuery) return '/';
  const trimmed = withoutQuery.replace(/\/+$/, '') || '/';
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const isPathBlocked = (pathname, blockList) => {
  const current = normalizeBlockedPath(pathname);
  if (!current || !Array.isArray(blockList) || blockList.length === 0) return false;
  return blockList.some((entry) => normalizeBlockedPath(entry) === current);
};
